(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gse-cart"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  // ---- Qty +/- buttons ----
  document.querySelectorAll('.gse-cart__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key    = btn.dataset.key;
      var action = btn.dataset.action;
      var input  = document.querySelector('.gse-cart__qty-input[data-key="' + key + '"]');
      if (!input) return;
      var qty = parseInt(input.value, 10);
      if (action === 'increase') qty++;
      if (action === 'decrease') qty = Math.max(0, qty - 1);
      input.value = qty;
      updateCartItem(key, qty);
    });
  });

  // ---- Remove button ----
  document.querySelectorAll('.gse-cart__remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      updateCartItem(btn.dataset.key, 0);
    });
  });

  // ---- Accessory add ----
  document.querySelectorAll('.gse-cart__accessory-add').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function () { location.reload(); });
    });
  });

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { location.reload(); });
  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.gse-cart__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key    = btn.dataset.key;
      var action = btn.dataset.action;
      var input  = document.querySelector('.gse-cart__qty-input[data-key="' + key + '"]');
      if (!input) return;
      var qty = parseInt(input.value, 10);
      if (action === 'increase') qty++;
      if (action === 'decrease') qty = Math.max(0, qty - 1);
      input.value = qty;
      updateCartItem(key, qty);
    });
  });

  document.querySelectorAll('.gse-cart__remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      updateCartItem(btn.dataset.key, 0);
    });
  });

  document.querySelectorAll('.gse-cart__accessory-add').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function () { location.reload(); });
    });
  });

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { location.reload(); });
  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
